import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'relativeTime' // The name of the pipe that you will use in the template
})
export class RelativeTimePipe implements PipeTransform {
  
  constructor(private datePipe: DatePipe) {}

  transform(value: Date | string): string {
    const date = new Date(value);  // Ensure that value is a Date object
    const now = new Date();

    // Format the time as "1:23 PM" (12-hour format with AM/PM)
    const formattedTime = this.datePipe.transform(date, 'h:mm a') || '';

    // Check the difference between now and the given date
    const diffInMs = now.getTime() - date.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInDays === 0) {
      return `${formattedTime} Today`;
    } else if (diffInDays === 1) {
      return `${formattedTime} Yesterday`;
    } else {
      // Format date in "MMM d, y h:mm a" (e.g., "Jul 14, 2023 1:23 PM")
      const formattedDate = this.datePipe.transform(date, 'MMM d, y') || '';
      return `${formattedDate} ${formattedTime}`;
    }
  }
}
